import { createContext } from "react";
import JobDto from "@/models/interfaces/dtos/production/job-dto";
import type { ProductionProcessOptions, ProductionProcessResult, ProjectProcessRunner } from "./project-process-runner";

export interface ProjectProcessContextProps {
    // Job suivi par le gestionnaire (calcul ou envoi), sinon job retrouvé par l'API.
    currentJob: JobDto | null;
    // Consulter aussi isLoading et error avant de conclure qu'aucun processus ne tourne.
    isProcessRunning: boolean;
    isLoading: boolean;
    isProcessStatusKnown: boolean;
    // Vérification immédiate, y compris avant le rendu suivant le début d'un lancement.
    isProcessBlockingEdits: () => boolean;
    error: Error | null;
    refreshProcess: () => Promise<void>;
    // Le processus reste actif jusqu'à l'appel de la fonction de fin retournée.
    beginProcess: () => () => void;
    runProductionProcess: (processName: string, jobUrl: string, options?: ProductionProcessOptions) => Promise<ProductionProcessResult>;
}

export const ProjectProcessContext = createContext<ProjectProcessContextProps | undefined>(undefined);
export const ProjectProcessRunnerContext = createContext<ProjectProcessRunner | undefined>(undefined);
